import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import materialUI from "material-UI";
import * as S from "./styles";

interface Option {
  label: string;
  value: string | number;
}

interface Props {
  onChange: (event: SelectChangeEvent<string | number>) => void;
  data: Array<Option>;
  label?: string;
  value: string | number;
  placeholder?: string;
  width?: string;
  disabled?: boolean;
  borderRadius?: string;
  error?: boolean;
}

const SelectComponent: React.FC<Props> = ({
  onChange,
  data,
  label,
  value,
  placeholder,
  width = "100%",
  disabled = false,
  borderRadius = "8px",
  error = false,
}) => {
  return (
    <S.Container width={width}>
      {label && <S.Label>{label}</S.Label>}
      <Select
        variant="outlined"
        value={value}
        onChange={onChange}
        displayEmpty
        disabled={disabled}
        size="small"
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: error ? "#D32F2F" : "#D0D5DD",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: error ? "#D32F2F" : "#2D5BFF",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: error ? "#D32F2F" : "#2D5BFF",
          },
          borderRadius,
          backgroundColor: "#fff",
        }}
        renderValue={(selected: any) =>
          selected ? (
            data.find((item) => item.value === selected)?.label
          ) : (
            <S.Placeholder>{placeholder}</S.Placeholder>
          )
        }
      >
        {data.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </S.Container>
  );
};

export default SelectComponent;
